import React from 'react';
import { Popup } from '@atlaskit/editor-common/ui';
export var FloatingToolbarLabel = /*#__PURE__*/React.memo(function (props) {
  var target = props.target,
    content = props.content,
    alignX = props.alignX,
    alignY = props.alignY,
    zIndex = props.zIndex,
    forcePlacement = props.forcePlacement,
    stick = props.stick,
    offset = props.offset;
  return /*#__PURE__*/React.createElement(Popup, {
    target: target,
    alignX: alignX,
    alignY: alignY,
    zIndex: zIndex,
    stick: stick,
    forcePlacement: forcePlacement,
    offset: offset
  }, content);
});